import { render } from "./HowToBuyPage.vue?vue&type=template&id=3ffde9dd"
import script from "./HowToBuyPage.vue?vue&type=script&lang=js"
export * from "./HowToBuyPage.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__